import React from "react";

import { useCurrentGame } from "../../../hooks/useCurrentGame";
import { useDeclarer } from "../../../hooks/useDeclarer";
import { Card } from "../shared/Card";
import { KING_SLUGS } from "../../../constants";
import { useSelector } from "react-redux";
import { selectIAmDeclarer } from "../../../store/selectors";

export const KingPicker: React.FC = () => {
  const { setPickedKing } = useCurrentGame();
  const { declarer } = useDeclarer();
  const iAmDeclarer = useSelector(selectIAmDeclarer);

  // should never happen
  if (declarer === undefined) {
    return <div className="text-emerald-200">Loading declarer...</div>;
  }

  if (!iAmDeclarer) {
    return (
      <div className="text-emerald-100 text-lg font-medium animate-pulse">
        Waiting for {declarer.name} to pick a King...
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-4 text-white">Pick a King</h2>
      <p className="text-emerald-200 mb-6">Your partner is whoever holds this King (if anyone)</p>
      <div className="flex space-x-4 items-center justify-center">
        {KING_SLUGS.map((kingSlug) => (
          <Card
            key={kingSlug}
            slug={kingSlug}
            onClick={() => setPickedKing(kingSlug)}
            enabled
          />
        ))}
      </div>
    </div>
  );
};
